export default [
    
    {  path:'/searchArticle',
      name:'SearchArticle',
      component:() => import('./Search')
    }
  ]